export default {
  params: ['otherField'],
  computesRequired: true,
  validate: (value, { otherField }) => {
    // if the other field is not empty, then validated field is optional
    if (!['', null, undefined].includes(otherField)) return true;
    // otherwise required
    return !['', null, undefined].includes(value);
  },
};
